import { AbilityContext } from "./ability-context";
import { useInheritContext } from "../ContextForwarder";

// higher order decorator for components that module props
export const withCan = (WrappedComponent) => (props) => {
    const value = useInheritContext("ability", AbilityContext);
    return <WrappedComponent {...props} can={value.can.bind(value)} />;
};
